// extracted by mini-css-extract-plugin
module.exports = {"footer":"MobileFooter_footer__cZvcO"};